import { Control, FieldValues } from "react-hook-form";

import { ITextFieldProps } from "components/_basic/Form/TextInput/TextInput/types";

import { ExpenseTable } from "../../../utils/form";

export const MONTHLY_EXPANSES_FIELD_TYPE = { 
  PERCENT: 'percent',
  GROWTH: 'growth',
  AMOUNT: 'amount'
} 

export type MonthlyExpansesFieldProps = Pick<ITextFieldProps, 'adornmentType'> & {
  name: string;
  watchFiledName: string;
  label: string;
  control: Control<FieldValues, any>;
  disabled?: boolean;
  fieldType: typeof MONTHLY_EXPANSES_FIELD_TYPE[keyof typeof MONTHLY_EXPANSES_FIELD_TYPE];
  watchedTableValues?: ExpenseTable[] | null,
  totalFirstMonthRevenue: string
}
